import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostListener
} from '@angular/core';

const TAG_LINK = 'A';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.pug',
    styleUrls: ['./alert.component.less']
})
export class AlertComponent {
    @Input() title: string = '';
    @Input() icon: string = '';
    @Input() message: string = '';
    @Input() innerHTML: string = '';
    @Input() buttonOkLabel: string = '';
    @Input() buttonCancelLabel: string = '';

    @Output() continue: EventEmitter<any> = new EventEmitter();
    @Output() cancel: EventEmitter<any> = new EventEmitter();
    @Output() close: EventEmitter<any> = new EventEmitter();

    @HostListener('click', ['$event.target'])
    onClick(event) {
        if (event.tagName !== TAG_LINK) {
            return;
        }

        this.close.emit();
    }

    constructor(
    ) {
    }

    onContinue() {
        this.continue.emit();
    }

    onCancel() {
        this.cancel.emit();
    }

    onClose() {
        this.close.emit();
    }
}
